import slick from 'slick-carousel';
import imgLiquid from 'plugs/imgLiquid-min.js';
import 'plugs/jquery.easing.1.3.js';
import 'plugs/svg.js';


var $window = $(window);
$(function() {
    $('body').addClass('fade-in');
    $("#topBtn").click(function() {
        $("html,body").animate({ scrollTop: 0 }, 1000, 'easeOutExpo');
        return false;
    });
    var winW,winH,footerH,bodyH,scrollTop;
    //mobile menu
    var menuicon = $('header .menuicon'),
    navBox = $('header .mmenu'),
    nav = $('header .navBox'),
    $body = $('body,html'),
    $header = $('header');

    menuicon.on('click',function(){
        var $this = $(this).parent('.headBox');
        if(!$this.hasClass('menu-expanded')){
            $this.addClass('menu-expanded');
            nav.stop().fadeIn();
            $body.css({'overflow':'hidden'}).addClass('modal_open');
        }else{
            $this.removeClass('menu-expanded');
            nav.stop().fadeOut(function(){$(this).removeAttr('style');});
            $body.css({'overflow':''}).removeClass('modal_open');
        }
        return false;
    });
    $('a[data-menu]').on('click',function(){
        var $this = $(this).parent();        
                
        if(!$this.hasClass('active')){
            $this.siblings().removeClass('active');
            $this.addClass('active');
        }else{
            $this.removeClass('active');
        }            
    });
    function resizeSubmen(){
        if($('ul.mmenu').length > 0 ){
        
            $('li.hasmenu').each(function( index ) {
                var offsetleft = $(this).offset().left;    
                var li_parent = $(this).outerWidth();
                var li_child = $(this).find('ul').outerWidth();
                var center_offset;
                center_offset = (li_child - li_parent) / 2;               
                var submen_o_left = offsetleft - center_offset;    
                $(this).find('ul').css('left',submen_o_left);
            });
        }
        
    }
    //siderbar menu click
    $('.sidebar > a').on('click',function(){
        var $this = $(this);
        $this.toggleClass('active');
        if($this.hasClass('active')){
            $this.next().stop().fadeIn();
        }else{            
            $this.next().stop().fadeOut(function(){$(this).removeAttr('style');});
        }
        return false;
    });
    //search click
    $('.headBox .searchbtn').on('click',function(){
        var $this = $('.nav_search');
        $this.toggleClass('active');
        if($this.hasClass('active')){
            $this.stop().fadeIn();
        }else{            
            $this.stop().fadeOut(function(){$(this).removeAttr('style');});
        }
        return false;
    });
    // hide menu start
    $(window).on('scroll', function() {
        scrollTop = $(this).scrollTop();
        var top = $('#topBtn');
        if (scrollTop >= 47) {
            top.addClass('open');
        }else{
            top.removeClass('open');
        }
        if($(window).scrollTop()>=$(document).height()-$(window).height() - $('footer').outerHeight(true)){
            top.addClass('change');          
        }else{
            top.removeClass('change');
        }
    }).scroll();
    
    $window.on('resize',function(){
        winW = $window.width();
        if(winW > 991){
            menuicon.parent('.headBox').removeClass('menu-expanded');
            $('.navBox').removeAttr('style');
            nav.stop().fadeOut(function(){$(this).removeAttr('style');});
            $body.css({'overflow':''});
        }
        $('li.hasmenu ul').removeAttr('style');
        setTimeout(function(){ resizeSubmen(); }, 800);

    }).resize();
    $('.slider-banner').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots:true,
        pauseOnHover:false,
        autoplay:true,
        autoplaySpeed:5000,
        speed:1500,
        pauseOnHover:false,
        fade:true,
        prevArrow:'<div class="btn_prev"></div>',
        nextArrow:'<div class="btn_next"></div>',
    });
    $('.catelist').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        dots:true,
        prevArrow:'<div class="btn_prev"></div>',
        nextArrow:'<div class="btn_next"></div>',
        responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 1,
              }
            }, 
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
              }
            },  
          ]
    });
    if($('.prod_detail').length > 0){
        $('.slider-for').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots:true,
            prevArrow:'<div class="btn_prev"></div>',
            nextArrow:'<div class="btn_next"></div>',
            asNavFor: '.slider-nav',
            draggable:false,
        });
        $('.slider-nav').slick({
            slidesToShow: 3,
            slidesToScroll: 1,            
            asNavFor: '.slider-for',
            focusOnSelect: true,
            draggable:false,
            prevArrow:'<div class="pg_prev"><img src="dist/images/pg_prev.png" /></div>',
            nextArrow:'<div class="pg_next"><img src="dist/images/pg_next.png" /></div>',
        });
        $('.prodbtn a').on('click',function(){
            var obj = $(this).data('id');
            $(this).siblings('.col-6').removeClass('active');
            $(this).addClass('active');
            $('#'+obj).siblings('.editor_Box').fadeOut(300);
            $('#'+obj).delay(300).fadeIn();
            return false;
        });
    }
});


